import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  Output,
} from '@angular/core';
import { MediaService } from '@studiobuki/web-core/lib/media';

@Component({
  selector: 'app-banner-one',
  templateUrl: './banner-one.component.html',
  styleUrls: ['./banner-one.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class BannerOneComponent {
  @Output() infoClick = new EventEmitter<void>();

  constructor(public mediaService: MediaService) {}

  public handleInfoClick() {
    this.infoClick.emit();
  }
}
